<template>
  <div class="deposito-popup">
    <div class="deposito-popup-header">
      <div class="chxy-row-bt header-view">
        <div class="header-left" @click="onClickLeft">
          <van-icon name="arrow-left" class="arrow-icon" size="16" />
        </div>
        <div class="header-center">{{ $t('deposito-pay.title') }}</div>
        <div class="header-right"></div>
      </div>
    </div>
    <div class="fix-h"></div>
    <div class="h-10"></div>
    <div class="chxy-row-c-c">
      <img :src="getImageUrlWithCDN_TEST('/deposito/pay-logo.png', 'local')" class="pay-logo" />
    </div>
    <div class="h-15"></div>
    <div class="line"></div>
    <div class="h-15"></div>
    <div class="chxy-row pay-desc">
      <div class="desc-dian"></div>
      <span class="desc-text">
        {{ $t('deposito-pay.desc1') }}
      </span>
    </div>
    <div class="h-20"></div>
    <div class="chxy-row pay-desc">
      <div class="desc-dian"></div>
      <span class="desc-text">
        {{ $t('deposito-pay.desc2') }}
      </span>
    </div>
    <div class="h-20"></div>
    <div class="chxy-row pay-desc">
      <div class="desc-dian"></div>
      <span class="desc-text highlight">
        {{ $t('deposito-pay.desc3') }}
      </span>
    </div>
    <div class="h-10"></div>

    <div class="chxy-row-c-c pay-money">
      <div class="pay-num">
        {{ currencySymbol
        }}{{ formatNumberWithComma(filterAmount(props.payInfo.amount) || '0.00') }}
      </div>
      <img
        class="pay-copy"
        :src="getImageUrlWithCDN_TEST('/deposito/copy.png')"
        @click="clickCopyAmount(formatNumberWithComma(filterAmount(props.payInfo.amount)))"
      />
    </div>
    <div class="h-5"></div>
    <div class="chxy-row-c-c q-code-view">
      <QRCode :value="payInfo.qcdoeNum" :size="180" />
    </div>
    <div class="chxy-row-c-c tempo-view">
      <span class="tempo-text">{{ $t('deposito-pay.effectiveTime') }}</span>
      <van-count-down :time="time" format="mm:ss" @finish="finishTime" @change="changeTime" />
    </div>

    <div class="chxy-row-c-c copiar-view" @click="clickCopyPublic(payInfo.qcdoeNum)">
      <img
        class="copiar-img"
        :src="getImageUrlWithCDN_TEST('/deposito/copy.png')"
        @click="clickCopyPublic(payInfo.qcdoeNum)"
      />
      <span @click="clickCopyPublic(payInfo.qcdoeNum)">{{ $t('deposito-pay.copyQr') }}</span>
    </div>
    <div class="chxy-row-c-c endereco-view">
      <span>{{ $t('deposito-pay.qrAddress') }}</span>
      <span>{{ filterQcdoeNumShow(payInfo.qcdoeNum) }}</span>
      <img
        class="endereco-img"
        :src="getImageUrlWithCDN_TEST('/deposito/copy.png')"
        @click="clickCopyPublic(payInfo.qcdoeNum)"
      />
    </div>
    <div class="h-50"></div>

    <!-- cell 区域 -->
    <!-- 刷新订单状态 -->
    <div class="chxy-row-bt m10">
      <div class="left-cell">{{ $t('deposito-pay.orderStatus') }}</div>
      <div class="chxy-row-ac">
        <span class="right-cell-status">{{ statusText }}</span>
        <img
          class="right-img"
          :class="{ 'play-status-loadding': playStatusLoadding }"
          :src="getImageUrlWithCDN_TEST('/activity/jz.png')"
          @click="refreshPlayStatus"
        />
      </div>
    </div>

    <div class="h-10"></div>
    <div class="chxy-row-bt m10">
      <div class="left-cell">{{ $t('deposito-pay.createTime') }}</div>
      <div class="chxy-row-ac">
        <!-- 02/12/2025 23:53:01 -->
        <span class="right-cell">{{ filterCreateTimeLShow(payInfo.createTimeL) }}</span>
      </div>
    </div>
    <div class="h-10"></div>
    <div class="chxy-row-bt m10">
      <div class="left-cell">{{ $t('deposito-pay.orderNumber') }}</div>
      <div class="chxy-row-ac">
        <span class="right-cell">{{ payInfo.merchantOrderId }}</span>
        <img
          class="right-img"
          :src="getImageUrlWithCDN_TEST('/deposito/copy.png')"
          @click="clickCopyPublic(payInfo.merchantOrderId)"
        />
      </div>
    </div>
    <div class="h-10"></div>
    <div class="chxy-row-bt m10">
      <div class="left-cell">{{ $t('deposito-pay.merchantOrderNumber') }}</div>
      <div class="chxy-row-ac">
        <span class="right-cell over-hidden-one">{{ payInfo.orderId }}</span>
        <img
          class="right-img"
          :src="getImageUrlWithCDN_TEST('/deposito/copy.png')"
          @click="clickCopyPublic(payInfo.orderId)"
        />
      </div>
    </div>

    <div class="h-20"></div>
  </div>
</template>

<script setup>
import { formatNumberWithComma } from '@/utils/format.js'
import QRCode from 'qrcode.vue'
import { rechargeQueryOrderInfoApi } from '@/api/deposito'
import { currencySymbol, getCurrencySymbol } from '@/utils/i18n'
const { t, locale } = useI18n()

const time = ref(30 * 60 * 1000)
const props = defineProps({
  payInfo: {
    type: Object,
    default: () => ({}),
  },
})

const onClickLeft = () => {
  emit('public-close')
}

const clickCopyAmount = async (val) => {
  try {
    const text = getCurrencySymbol() + val
    await navigator.clipboard.writeText(text)
    showToast(t('deposito-pay.copiedSuccess'))
  } catch (error) {
    console.log('error ----- ', error)
  }
}

const clickCopyPublic = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
    showToast(t('deposito-pay.copiedSuccess'))
  } catch (error) {
    console.log('error ----- ', error)
  }
}

// 充值金额过滤
const filterAmount = (amount) => {
  // 分转元
  const newAmount = amount / 100
  return newAmount.toFixed(2)
}

const changeTime = (event) => {
  // console.log('changeTime...')
}

const finishTime = () => {
  emit('public-close')
}

//
const filterCreateTimeLShow = (value) => {
  // time 时间戳 显示成 日/月/年 时分秒
  if (!value) return ''

  // 如果是时间戳，转换为毫秒
  let timestamp = value
  if (typeof value === 'string' && /^\d+$/.test(value)) {
    // 判断是秒还是毫秒
    timestamp = value.length === 10 ? parseInt(value) * 1000 : parseInt(value)
  } else if (typeof value === 'number') {
    // 判断是秒还是毫秒
    timestamp = value.toString().length === 10 ? value * 1000 : value
  }

  const date = new Date(timestamp)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
}
const filterQcdoeNumShow = (value) => {
  if (value && value.length > 8) {
    // 切割当前字符串的最后8位数
    return '**' + value.substring(value.length - 8, value.length - 1)
  }
  return '*******'
}

// 刷新充值状态
watch(
  () => props.payInfo.status,
  (val) => {
    console.log('watch val ----- ', val)
    if (val) {
      playStatus.value = val
    }
  }
)

const playStatus = ref('00')
const statusText = computed(() => {
  return t(`deposito-pay.status.${playStatus.value}`)
})
const playStatusLoadding = ref(false)
const refreshPlayStatus = async () => {
  playStatusLoadding.value = true
  try {
    const res = await rechargeQueryOrderInfoApi({
      order_no: props.payInfo.merchantOrderId,
    })
    if (res.code == 1) {
      playStatus.value = res.data.status
    }
  } catch (error) {
    // console.log('error ----- ', error)
  } finally {
    playStatusLoadding.value = false
  }
}

const emit = defineEmits(['public-close'])
</script>

<style lang="scss" scoped>
.pay-logo {
  width: 113px;
  height: 40px;
}
.deposito-popup {
  background-color: var(--deposito-view-bg);
  height: calc(100vh - 45px);
  height: calc(100dvh - 45px);
  width: 100vw;
  border-radius: 10px 10px 0 0;
  overflow-y: scroll;

  .deposito-popup-header {
    position: fixed;
    .header-view {
      width: 100vw;
      height: 46px;
      width: 100vw;
      border-radius: 10px 10px 0 0;
      background: var(--deposito-view-bg);
      .header-left {
        margin-left: 10px;

        .arrow-icon {
          color: var(--deposito-arrow-icon);
        }
      }
      .header-center {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 16px;
        color: var(--deposito-card-title);
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .header-right {
        margin-right: 10px;
      }
    }
  }
}
.fix-h {
  height: 50px;
}
.m10 {
  margin: 0 10px;
}

.pay-desc {
  margin: 0 14px;
  .desc-dian {
    width: 5px;
    height: 5px;
    background: var(--deposito-card-value);
    border-radius: 5px;
    margin-top: 5px;
    margin-right: 5px;
  }
  .desc-text {
    width: 340px;
    height: 24px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 11px;
    color: var(--deposito-card-value);
    text-align: left;
    font-style: normal;
    text-transform: none;

    &.highlight {
      color: var(--deposito-card-value__highlight);
    }
  }
}
.pay-money {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 25px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .pay-num {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 25px;
    color: var(--deposito-qr-code-amount-text);
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .pay-copy {
    width: 15px;
    height: 16px;
    margin-left: 5px;
  }
}
.q-code-view {
  width: 180px;
  height: 180px;
  background-color: var(--deposito-qr-code-bg);
  margin: 0 auto;
}
.tempo-view {
  margin-top: 5px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 11px;
  font-style: normal;
  text-transform: none;
  --van-count-down-font-size: 12px;
  --van-count-down-text-color: var(--deposito-qr-code-name-text);

  .tempo-text {
    margin-right: 5px;
    color: var(--deposito-qr-code-name-text);
  }
}

.copiar-view {
  width: 162px;
  height: 34px;
  background: var(--deposito-card-button-bg);
  margin: 0 auto;
  border-radius: 7px;
  color: var(--deposito-card-button-text);
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 11px;
  text-align: left;
  font-style: normal;
  text-transform: none;

  .copiar-img {
    width: 11px;
    height: 12px;
    margin-right: 5px;
  }
}
.endereco-view {
  margin-top: 5px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 11px;
  color: var(--deposito-qr-code-name-text);
  text-align: left;
  font-style: normal;
  text-transform: none;
  .endereco-img {
    width: 11px;
    height: 12px;
    margin-left: 5px;
  }
}
.h-50 {
  height: 50px;
}
.h-60 {
  height: 60px;
}
.left-cell {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 11px;
  color: var(--deposito-card-label);
  text-align: left;
  font-style: normal;
  text-transform: none;
  width: 210px;
}
.right-cell {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 11px;
  color: var(--deposito-card-value);
  text-align: right;
  font-style: normal;
  text-transform: none;
  width: 145px;
}
.right-cell-status {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 11px;
  color: var(--deposito-card-value__highlight);
  text-align: right;
  font-style: normal;
  text-transform: none;
}

.right-img {
  width: 9px;
  height: 9px;
  margin-left: 5px;
  &.play-status-loadding {
    animation: rotate 0.5s linear infinite;
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.line {
  width: 355px;
  height: 1px;
  background: var(--deposito-card-border-bottom);
}
</style>
